import { createContext, useContext } from 'react';

interface RouteInfo {
  isNmrium: boolean;
}

export const routeInfoContext = createContext<RouteInfo>({ isNmrium: false });

export const RouteInfoProvider = routeInfoContext.Provider;

export function useRouteInfo() {
  return useContext(routeInfoContext);
}
